import Image1 from "../../images/home/hero-image1.png";
import Image1_1 from "../../images/home/hero-image1_1.png";
import Stardust from "../../images/home/stardust.png";
import Stardust1 from "../../images/home/stardust1.png";
import Image2 from "../../images/home/hero-image2.png";
import Vector1 from "../../images/home/Vector 1.png";
import Vector2 from "../../images/home/Vector 2.png";
import Stack1 from "../../images/home/stack1.png";
import Stack2 from "../../images/home/stack2.png";
import Stack3 from "../../images/home/stack3.png";
import Stack4 from "../../images/home/stack4.png";
import { useNavigate } from "react-router-dom";

function HomeHero() {
  const navigate = useNavigate();

  return (
    <div className="home-hero">
      <div className="home-hero-heading">
        <h1>Building scalable software solutions for enterprise</h1>
        <p>
          We design and develop robust cloud-native solutions that empower
          businesses to scale efficiently, improve performance, and position
          long-term growth
        </p>
        <button onClick={() => navigate("/contact-us")}>
          <p>Contact Us</p>
          <div className="home-hero-heading-button-arrow" />
        </button>
      </div>
      <div className="home-hero-image">
        <img className="image1" src={Image1} alt="Default" />
        <div className="home-hero-image-div">
          <img className="image1_1" src={Image1_1} alt="Default" />
        </div>
      </div>
      <div className="home-hero-image2">
        <img src={Image2} alt="Default" />
      </div>
      <div className="home-hero-stack">
        <div className="home-hero-stack-div">
          <h2 className="home-hero-stack-heading">Brandone stack</h2>
          <div className="stack1">
            <p>Intuitive Design</p>
            <img src={Stack1} alt="stack" />
          </div>
          <div className="stack2">
            <p>Dev. & Integration</p>
            <img src={Stack2} alt="stack" />
          </div>
          <div className="stack3">
            <p>Testing & QA</p>
            <img src={Stack3} alt="stack" />
          </div>
          <div className="stack4">
            <p>Deployment</p>
            <img src={Stack4} alt="stack" />
          </div>
        </div>
        <div className="home-hero-stack-shape" />
      </div>
      <div className="home-hero-stardust">
        <img src={Stardust1} className="stardust1" alt="stardust" />
        <img src={Stardust} className="stardust" alt="stardust" />
      </div>
      <img className="home-hero-vector1" src={Vector1} alt="Vector" />
      <img className="home-hero-vector2" src={Vector2} alt="Vector" />
      <canvas className="home-hero-rectangle" />
    </div>
  );
}

export default HomeHero;
